import { render, staticRenderFns } from "./GoForMorkov.html?vue&type=template&id=31467480&external"
import script from "./GoForMorkov.js?vue&type=script&lang=js&external"
export * from "./GoForMorkov.js?vue&type=script&lang=js&external"
import style0 from "./GoForMorkov.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports